angular.module('CarsSaraBo').directive('opaqueRateAddComponent', function () {
	return {
		restrict: 'E',
		controller: ['$routeParams', 'OpaqueRateService', 'LoadingWheelService', 'NotificationService', 'OpaqueRateGAConfig', 'SessionService', 'FleetService', 'PointOfSaleService',
			'ItemSelectorService', '$location', 'ModalService', 'DateService', '$rootScope', '$q', OpaqueRateAddController],
		controllerAs: 'ctrl',
		templateUrl: 'templates/opaque-rate/opaque-rate-add.component.html',
		scope: {} // isolated scope
	};
});

function OpaqueRateAddController($routeParams, opaqueRateService, loadingWheelService, notificationService, opaqueRateGAConfig, sessionService, fleetService, pointOfSaleService,
								 itemSelectorService, $location, modalService, dateService, $rootScope, $q) {
	var vm = this;
	var gaOpaqueRate = opaqueRateGAConfig.reviewGa();
	gaOpaqueRate.send("Page_view");
	vm.companyOid = $routeParams.companyOid;
	vm.carsSelector = {};
    vm.pointsOfSaleSelector = {};
	vm.opaque = {dateRange: {}, name: null, discount: 10};
	vm.errorField = {};
	vm.errorList = [];
	vm.notifyErrorList = [];
	vm.validationErrors = [];

	var helpForm = {
		es: "https://docs.google.com/forms/d/e/1FAIpQLSdCIykFWGGevr29LTWFwTXH7RdwVvUCB3mGg12IReBqemGjBQ/viewform?usp=sf_link",
		pt: "https://docs.google.com/forms/d/e/1FAIpQLSdudhJUeYg0ioi-CDMdjwlCVGUl2DgrS_VX5cis8n6fsbnrag/viewform?usp=sf_link",
		en: "https://docs.google.com/forms/d/e/1FAIpQLSdN33cKGghW-elnYooAnmK_scvJdLcUwhzZSOwTbdMJTJg0JA/viewform?usp=sf_link"
	};

	vm.initialize = function () {
		$rootScope.ignoreGlobalHttpErrorHandling = true;
		loadingWheelService.show();
		function getFleet() {
			var fieldsCar = "oid,name,carModel";
			fleetService.get({companyOid: vm.companyOid, fields: fieldsCar}, function (response) {
				vm.fleet = response;
				vm.carsSelector = getCarsSelectorConfig(vm.fleet, []);
			});
		}

        function getPointsOfSale() {
            pointOfSaleService.resource.query({companyOid: vm.companyOid}, function (pointsOfSale) {
            	vm.pointsOfSaleSelector = pointOfSaleService.getPointsOfSaleSelectorConfig(pointsOfSale, []);
            });
        }

		getFleet();
		getPointsOfSale();
        loadingWheelService.hide();
		vm.editableOpaqueRate = sessionService.loggedUserAllowed('PERM_OPAQUE_RATE_CREATE');
        vm.modalOpaque = document.querySelector("dsp-modal-coachmark");
	}

    vm.showModal = function () {
        vm.modalOpaque.show();
        gaOpaqueRate.send("Modal_ayuda_desde_crear_tarifa", "Clicks");
    }

	function getCarsSelectorConfig(fleet, selectedCars) {
		var nameGenerator = function (car) {
			return car.carModel.brand + ' ' + car.carModel.model + ' - ' + car.name;
		};
		var cars = itemSelectorService.getItemsForSelector(fleet, selectedCars, nameGenerator);

		return itemSelectorService.newItemSelectorBuilder()
			.listOfItemsTitle("specialOffers.carsSelector.listOfItemsTitle")
			.listOfSelectedItemsTitle("specialOffers.carsSelector.listOfSelectedItemsTitle")
			.items(cars)
			.build();
	}

	function goBack() {
		$location.path("/company/" + $routeParams.companyOid + "/opaquerate");
	}

	vm.cancel = function () {
		gaOpaqueRate.send("Cancelar");
		modalService.show("CANCEL_ALERT_TITLE", "OR.CANCEL_ALERT_DESCRIPTION", function () {
			goBack();
		});
	}

	function toObject(oid) {
		return {
			'oid': oid
		}
	}

    function buildRequest(opaque, carsSelector, posSelector) {
        return {
            name: opaque.name,
            discountPercentage: opaque.discount,
            validityPeriod: {
                from: dateService.customFormatDate(opaque.dateRange.from, "yyyyMMdd"),
                to: dateService.customFormatDate(opaque.dateRange.to, "yyyyMMdd")
            },
            cars: _.map(carsSelector.getSelectedItemsOid(), toObject),
            pointsOfSale: _.map(posSelector.getSelectedItemsOid(), toObject)
        }
    }

    function isValidForm() {
        var isValid = true;

        if (!_.some(vm.pointsOfSaleSelector.getSelectedItemsOid())) {
            isValid = false;
            vm.errorField['pointsOfSale'] = 'input-error';
            vm.notifyErrorList.push({field:'pointsOfSale', message:'required'});
        }

        if (!_.some(vm.carsSelector.getSelectedItemsOid())) {
            isValid = false;
            vm.errorField['cars'] = 'input-error';
            vm.notifyErrorList.push({field:'cars', message:'required'});
        }

        if (!!vm.opaque.dateRange) {
            var period = vm.opaque.dateRange;
            if (!dateService.isValidFromDate(period)) {
                isValid = false;
                vm.errorField['opaqueDateRange-from'] = {
                    class: "-invalid",
                    message: "specialOffers.errors.validityPeriod.invalidFromDate"
                };
                vm.notifyErrorList.push({field:'paqueDateRange-from', message:'invalidFromDate'});
                vm.validationErrors.push({code:"specialOffers.errors.validityPeriod.invalidFromDate"});
            }
            if (!dateService.isValidToDate(period)) {
                isValid = false;
                vm.errorField['opaqueDateRange-from'] = {
                    class: "-invalid",
                    message: "contract.ERROR_FROM_TO_DATE"
                };
                vm.notifyErrorList.push({field:'paqueDateRange-to', message:'invalidFromDate'});
                vm.validationErrors.push({code:"contract.ERROR_FROM_TO_DATE"});
            }
        } else {
            isValid = false;
            vm.errorField['opaqueDateRange-from'] = {
                class: "-invalid",
                message: "common.form.validation.UNCOMPLETE_REQUIRED_FIELD"
            };
            vm.notifyErrorList.push({field:'paqueDateRange', message:'required'});

        }
        return isValid;
    }

    vm.save = function () {
        var deferred = $q.defer();
        vm.notifyErrorList = [];
        vm.validationErrors = [];

        vm.errorField = {};

		gaOpaqueRate.send("Guardar_tarifa_opaca", vm.opaque.discount);

		if (isValidForm() && vm.opaqueRateForm.$valid) {
			var opaqueRequest = buildRequest(vm.opaque, vm.carsSelector, vm.pointsOfSaleSelector);
			opaqueRateService.save(vm.companyOid, opaqueRequest).then(function (response) {
				notificationService.displayToast('opaqueRate.TITLE', 'opaqueRate.toast.confirmationMessage.SUCCESS_SAVE');
                deferred.resolve();
				goBack();
			}, function (error) {
                deferred.reject();
				console.error("[Opaque rate] Error while trying to save.", error);
				handleError(error);
			});
		} else {
            deferred.reject();
			handleErrorValidation();
		}
		return deferred.promise;
	};

	function mapMessage(name) {
		if(name === 'opaqueStepper'){
			return 'opaqueRate.validations.discount';
		}else{
			return 'warning.invalidNumberFormat';
		}
	}

	function handleErrorValidation() {
		for (i in vm.opaqueRateForm.$error.required) {
			vm.errorField[vm.opaqueRateForm.$error.required[i].$name] = {
				class: "-invalid",
				message: "common.form.validation.UNCOMPLETE_REQUIRED_FIELD"
			};
			vm.notifyErrorList.push({field:vm.opaqueRateForm.$error.required[i].$name, message:'required'});
		}

		for (i in vm.opaqueRateForm.$error.min) {
			vm.errorField[vm.opaqueRateForm.$error.min[i].$name] = {
				class: "-invalid",
				message: mapMessage(vm.opaqueRateForm.$error.min[i].$name)
			};
			vm.notifyErrorList.push({field:vm.opaqueRateForm.$error.min[i].$name, message:'min-value'});
		}

		for (i in vm.opaqueRateForm.$error.max) {
			vm.errorField[vm.opaqueRateForm.$error.max[i].$name] = {
				class: "-invalid",
				message: mapMessage(vm.opaqueRateForm.$error.max[i].$name)
			};
			vm.notifyErrorList.push({field:vm.opaqueRateForm.$error.max[i].$name, message:'max-value'});
		}

		notifyErrorsToAnalytics();
        notifyFormErrors(vm.opaqueRateForm.$error);
	}

	function notifyFormErrors(errors) {
        var carsNotSelected = vm.errorField.cars != undefined;
        var posNotSelected = vm.errorField.pointsOfSale != undefined;

        var hasRequiredError = errors != undefined && errors.required && errors.required.length > 0;

        if (hasRequiredError || carsNotSelected || posNotSelected) {
            vm.validationErrors.push({code:"opaqueRate.validations.completeRequiredFields"});
        }

        document.getElementById('error-message-container').scrollIntoView();
    }

	function handleError(responseError) {
		console.log("responseError", responseError);
		if (responseError.data && responseError.data.params) {
			vm.validationErrors = [{code: responseError.data.message, param:responseError.data.params}];
			vm.notifyErrorList.push({field:responseError.data.message, message:JSON.stringify(responseError.data.params)});
		} else {
			if(Array.isArray(responseError.data)) {
                vm.validationErrors = _.map(responseError.data, function(code){
                    vm.notifyErrorList.push({field:code});
                    return {code:code, param:null};
                });
            } else {
                vm.notifyErrorList.push({field:"form", message: responseError.data});
			}
		}
		notifyErrorsToAnalytics();
		document.getElementById('error-message-container').scrollIntoView();
	}

	vm.redirectToHelpForm = function () {
		gaOpaqueRate.send("Boton_consulta");
		window.open(helpForm[$rootScope.lang.value]);
	}

	function notifyErrorsToAnalytics() {
		_.each(vm.notifyErrorList, function(error){
			gaOpaqueRate.send("Errores_de_validacion", error.field, error.message);
		})
	}

	vm.initialize();

};


//////////////////
// WEBPACK FOOTER
// ./public/app/opaque-rate/opaque-rate-add.component.js
// module id = 829
// module chunks = 3